import React, {useEffect, useState} from "react";

import {Plus as AddIcon} from "react-feather"
import styles from "./style.module.css"
import Dropzone from 'react-dropzone';

import {
    BackButton,
    Button,
    Centered,
    CircularProgress,
    FlexRowSpaceBetween,
    FormControl,
    Paper,
    Space,
    TextField,
    Typography,
} from "../../../../common/components/libs";

import {observer} from "mobx-react";
import {useStores} from "../../../../hooks";
import {
    BookingBadgeType,
    BookingScheduleSettingsType,
    MediaItems,
    MediaType,
    MenuBookingItem as BookingItemType
} from "../../../../services/menu/models";
import {uploadFile} from "../../../../services/files";
import {
    Checkbox,
    FormControlLabel,
    FormGroup,
    Hidden,
    InputAdornment,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableRow
} from "@material-ui/core";
import {useHistory, useParams} from "react-router-dom";

import {
    changeCheckboxEventHandlerDecorator,
    changeEventHandlerDecorator,
} from "../../../../common/libs";
import {FadeInOutVertical} from "../../../../common/components/Animated";
import EditModifiersSetInline from "../modifiersSet/components/EditModifiersSetInline";
import AddModifiersSetToMenuItemForm from "./components/AddModifiersSetToMenuItemForm";
import {SnackbarType} from "../../../../stores/common";
import {Delete as RemoveIcon} from "@material-ui/icons";
import ImageCropperForm, {ImageAspectRatio} from "../../../../common/components/ImageCropperForm";
import {Trans, useTranslation} from "react-i18next";
import {BookingFormType} from "../../store/booking/forms";
import DeleteMenuItemForm from "./components/DeleteMenuItemForm";
import LocalizedInput from "../../../../common/components/translation/LocalizedInput";
import {defaultMediaItems} from "./components/CreateMenuBookingForm";
import style from './style.module.css';
import EditBookingSheduleForm from "./components/EditBookingSheduleForm";
import moment from "moment";


const EditBookingItemPage = () => {
    const {t, ready} = useTranslation(["general", "menu"], {useSuspense: false});
    const {bookingStore, generalStore, constantsStore, modifiersSetsStore, translationStore} = useStores();

    const locale = generalStore.locale.id;
    const currencyId = generalStore.currency.id;

    const [price, setPrice] = useState(0);
    const [priceToShow, setPriceToShow] = useState("");
    const [sortOrder, setSortOrder] = useState(0);
    const [isUploadInProgress, setIsUploadInProgress] = useState(false);
    const [currentFile, setCurrentFile] = useState<File | undefined>();
    const [category, setCategory] = useState<number | null>();
    const [isInStopList, setIsInStopList] = useState(false);
    const [amount, setAmount] = useState(0)

    const [newBadgeChecked, setNewBadgeChecked] = useState<boolean>(false);
    const [profitableBadgeChecked, setProfitableBadgeChecked] = useState<boolean>(false);
    const [hitBadgeChecked, setHitBadgeChecked] = useState<boolean>(false);

    const [media, setMedia] = useState<MediaItems[]>([]);
    const [fileName, setFileName] = useState<string>("");
    const [isUploadPreviewInProgress, setIsUploadPreviewInProgress] = useState(false);
    const [isUploadRegularInProgress, setIsUploadRegularInProgress] = useState(false);
    const [isImagePreviewCropperVisible, setIsImagePreviewCropperVisible] = useState(false);
    const [isImageRegularCropperVisible, setIsImageRegularCropperVisible] = useState(false);
    const [sourceId, setSourceId] = useState("");
    const [mediaType, setMediaType] = useState<MediaType>(MediaType.source);
    const [ mediaLinks, setMediaLinks] = useState<MediaItems>(defaultMediaItems);

    const [modifiersSets, setModifiersSets] = useState<{ menuItemModifierSetId: number, sortOrder: number }[]>([]);
    const history = useHistory();
    const params = useParams<{ menuId: string, categoryId: string, menuItemId: string }>();
    const menuId = parseInt(params.menuId);
    const menuItemId = parseInt(params.menuItemId);
    const categoryId = parseInt(params.categoryId);

    const currencyFormatter = constantsStore.getCurrencyFormatter(generalStore.currency.id);

    const [isAddModifersSetFormVisible, setIsAddModifersSetFormVisible] = useState(false);

    const getRemoveModifiersSet = (index: number) => () => {
        const newModifiers = [...modifiersSets];
        newModifiers.splice(index, 1);
        setModifiersSets(newModifiers)
    };

    const [current, setCurrent] = useState<BookingItemType | undefined>();



    const getFile = async (url: string) => {
        let file: File;
        let response = await fetch(url);
        const blob: Blob = await response.blob();
        file = new File([blob], "image.jpeg");
        setCurrentFile(file)
    }

    useEffect(() => {
        (async () => {
            await modifiersSetsStore.ensureLoaded();
            await bookingStore.fetchMenuById(menuId);
        })();
    }, [menuId]);

    useEffect(() => {
        const menu = bookingStore.currentMenu;
        if (!menu) return;
        const current = bookingStore.getMenuItemByCategoryIdAndId(categoryId, menuItemId);
        translationStore.setLangs(menu.menu.data.availableLanguages);
        if (!current) return;
        setCurrent(current);

        if(current.data.media.length > 0){
            setMediaLinks(current.data.media[0]);
            const t = current.data.media[0];
            if (t && t.source) {
                getFile(t.source);
            }
        }
        generalStore.setPageTitle(t("general:editing"));
    }, [bookingStore.currentMenu, generalStore, menuItemId, categoryId, bookingStore, ready]);

    useEffect(() => {
        if (current) {
            setAmount(current.data.amount);
            setPrice(current.data.sellPrice.price);
            setPriceToShow(currencyFormatter.toShow(current.data.sellPrice.price, true));
            setSortOrder(current.data.sortOrder);
            setMedia(current.data.media);
            setIsUploadInProgress(false);
            setCurrentFile(undefined);
            setModifiersSets(current.data.menuItemModifierSets);
            setCategory(categoryId);
            setIsInStopList(current.data.isInStopList);
            bookingStore.currentMenuItem = current;
            bookingStore.setBookingScheduleSettings()


            setMediaLinks(current.data.media.length > 0 ? current.data.media[0] : defaultMediaItems);
            setSourceId(current.data.media.length > 0 ? current.data.media[0].sourceId : "");


            const newBadge = current.data.badges[BookingBadgeType.new];
            setNewBadgeChecked(newBadge?.isEnabled || false);

            const profitableBadge = current.data.badges[BookingBadgeType.profitable];
            setProfitableBadgeChecked(profitableBadge?.isEnabled || false);

            const hitBadge = current.data.badges[BookingBadgeType.hit];
            setHitBadgeChecked(hitBadge?.isEnabled || false);


        } else {
            setAmount(0);
            setPrice(0);
            setPriceToShow("");
            setSortOrder(0);
            setIsUploadInProgress(false);
            setCurrentFile(undefined);
            setModifiersSets([]);
            setCategory(null);
            setIsInStopList(false);
            setMedia([])
        }

    }, [current]);




    if (!bookingStore.currentMenu) return null;
    if (bookingStore.currentMenu.menuCategories.length === 0) return null;
    if (bookingStore.selectedCategory === undefined) return null;
    if (!current) return;
    const timeFromSlot = new Date().setHours(bookingStore.bookingScheduleSettings.fromHour, bookingStore.bookingScheduleSettings.fromMinute, 0)
    const timeToSlot = new Date().setHours(bookingStore.bookingScheduleSettings.toHour, bookingStore.bookingScheduleSettings.toMinute, 0)




    const setPriceWrapper = (value: string) => {
        if(currencyFormatter.toFloat(value) < 0) return;
        setPrice(currencyFormatter.toSend(currencyFormatter.toFloat(value)));
        setPriceToShow(currencyFormatter.toStringFloat(value));
    };

    const handleSubmit = async () => {

        const res = await bookingStore.updateBookingItem(current.id, {
            badges: {
                ...current.data.badges,
                [BookingBadgeType.new]: {
                    isEnabled: newBadgeChecked,
                    type: BookingBadgeType.new
                },
                [BookingBadgeType.profitable]: {
                    isEnabled: profitableBadgeChecked,
                    type: BookingBadgeType.profitable
                },
                [BookingBadgeType.hit]: {
                    isEnabled: hitBadgeChecked,
                    type: BookingBadgeType.hit
                },
            },
            name: bookingStore.currentMenuItem.data.name,
            description: bookingStore.currentMenuItem.data.description,
            sortOrder,
            isInStopList: isInStopList,
            menuBookingCategoryId: category,
            menuItemModifierSets: modifiersSets,
            sellPrice: {
                price: price,
                currencyId: currencyId
            },
            media: media,
            amount: amount,
            menuBookingItemSuggestions: [],
            bookingScheduleSettings: {
                type: BookingScheduleSettingsType.withinDayByStep,
                step:  bookingStore.bookingScheduleSettings.step,
                fromHour:  bookingStore.bookingScheduleSettings.fromHour,
                fromMinute: bookingStore.bookingScheduleSettings.fromMinute,
                toHour: bookingStore.bookingScheduleSettings.toHour,
                toMinute: bookingStore.bookingScheduleSettings.toMinute,
            }
        });

        if (res.err) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:menuEditor.failedSavePosition"),
                type: SnackbarType.error
            })
        } else {
            generalStore.showSnackbar({
                title: t("menu:menuEditor.menuPositionUpdated"),
                type: SnackbarType.success
            })
        }
        history.push(`/menus/booking/${current.menuId}/view`);
        bookingStore.resetBookingScheduleSettings();
    };


    const checkSource = (str: string) => {
        return str.includes(sourceId);
    }

    const closeAddModifierSetForm = () => {
        setIsAddModifersSetFormVisible(false);
    };
    const submitAddModifiersSetForm = (modifierSetId: number) => {
        const newModifiers = [
            ...modifiersSets,
            {
                menuItemModifierSetId: modifierSetId,
                sortOrder: 1
            }
        ];
        setModifiersSets(newModifiers);
        closeAddModifierSetForm();
    };



    const openDeleteForm = (current?: BookingItemType) => {
        bookingStore.forms.showPopupForm(BookingFormType.deleteBookingItem, current);
    }

    const openScheduleForm = (current?: BookingItemType) => {
        bookingStore.forms.showPopupForm(BookingFormType.editTimeSlots, current);
    }

    const uploadImage = async (file: File) => {
        setIsUploadInProgress(true);
        const newMediaLinks = {...mediaLinks}

        try {
            const res = await uploadFile(file, MediaType.source);
            const { downloadUrl, sourceIdentifier } = res;
            setSourceId(sourceIdentifier);
            newMediaLinks.sourceId = sourceIdentifier;
            newMediaLinks.source = downloadUrl;
            newMediaLinks.preview = downloadUrl;
            newMediaLinks.previewHighRes = downloadUrl;
            newMediaLinks.regular = downloadUrl;
            newMediaLinks.regularHighRes = downloadUrl;
            //setMediaLinks({...mediaLinks, source: downloadUrl});
        } catch (e) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:menuEditor.failedLoadIMG"),
                type: SnackbarType.error
            })
        } finally {
            let arr = media;
            arr[0] = newMediaLinks;
            setMediaLinks(newMediaLinks);
            setMedia(arr);
            setIsUploadInProgress(false);
        }
        return;
    };

    const customizeImage = async (file: File) => {
        try {
            if (!media[0]?.source) return;
            setFileName('');
            const res = await uploadFile(file, mediaType, sourceId);
            const { downloadUrl, highResDownloadUrl } = res;
            if (mediaType === MediaType.preview) {
                mediaLinks.preview = downloadUrl;
                mediaLinks.previewHighRes = highResDownloadUrl;
                setFileName(`${sourceId + '_preview.jpeg'}`)
                //setMediaLinks({...mediaLinks, preview: downloadUrl});
                // setMediaLinks({...mediaLinks, previewHighRes: highResDownloadUrl});
                let arr = media;
                arr[0] = mediaLinks;
                setMedia(arr);

            }
            if (mediaType === MediaType.regular) {
                mediaLinks.regular = downloadUrl;
                mediaLinks.regularHighRes = highResDownloadUrl;
                setFileName(`${sourceId + '_regular.jpeg'}`)
                // setMediaLinks({...mediaLinks, regular: downloadUrl});
                // setMediaLinks({...mediaLinks, regularHighRes: highResDownloadUrl});
                let arr = media;
                arr[0] = mediaLinks;
                setMedia(arr);
            }

            media[0] = mediaLinks;
        } catch (e) {
            generalStore.showSnackbar({
                title: t("general:error"),
                description: t("menu:menuEditor.failedLoadIMG"),
                type: SnackbarType.error
            })
        } finally {
            if (mediaType === MediaType.preview) setIsUploadPreviewInProgress(false);
            if (mediaType === MediaType.regular) setIsUploadRegularInProgress(false);
        }
        return;
    };


    const onDrop = async (files: File[]) => {
        setCurrentFile(files[0]);
        await uploadImage(files[0]);
    };


    let imageBlockContent = [];


    if (!isUploadInProgress && media.length === 0) {
        imageBlockContent.push(
            <Dropzone onDrop={onDrop} key='1'>
                {({getRootProps, getInputProps}) => (
                    <div {...getRootProps({className: styles.dropzone})}
                         style={{minHeight: "200px", minWidth: "200px", width: "100%"}}>
                        <input {...getInputProps()} />
                        <AddIcon size={30}/>
                        <span>{t("general:load")}</span>
                    </div>
                )}
            </Dropzone>
        )
    } else if (isUploadInProgress) {
        imageBlockContent.push(
            <div key='2'
                 style={{
                     minHeight: "200px",
                     minWidth: "200px",
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center"
                 }}
            >
                <CircularProgress
                    m={2}
                    color="secondary"
                />
            </div>
        )
    }
    if (media.length > 0) {
        imageBlockContent.push(
            <div className={style.imagesBlock}>
                <div key='1'>
                    <img
                        src={media[0].source}
                        alt=""
                        key={media[0].source}
                        className={style.image}
                    />
                </div>
                <Dropzone onDrop={onDrop} key='4'>
                    {({getRootProps, getInputProps, open}) => (
                        <div {...getRootProps()}
                             style={{textAlign: 'center'}}>
                            <input {...getInputProps()}  />
                            <Button color={"primary"} style={{marginTop: -10}}>{t("general:replace")}</Button>
                        </div>
                    )}
                </Dropzone>
            </div>,
            <div className={style.imageBlock}>
                { (mediaLinks.preview.length > 0 && checkSource(mediaLinks.preview))    &&
                    <div className={styles.menuItemEditor} key="cmif_4">
                        <img src={`${mediaLinks.preview}?${Math.random().toString(36)}`}
                             className={style.previewImage}
                             alt=""
                             key={mediaLinks.preview}
                        />
                    </div>
                }
                {!isUploadPreviewInProgress ?
                    <Button color={"primary"}
                            onClick={() => {
                                setMediaType(MediaType.preview);
                                setCurrentFile(currentFile);
                                setIsUploadPreviewInProgress(true);
                                setIsImagePreviewCropperVisible(true);
                            }}>
                        {t("menu:menuEditor.customizePreview")}</Button>
                    :
                    <CircularProgress
                        m={2}
                        color="secondary"
                    />
                }</div>,
            <div className={style.imageBlock}>
                { (mediaLinks.regular.length > 0 && checkSource(mediaLinks.regular)) &&
                    <div className={styles.menuItemEditor} key="cmif_4">
                        <img src={`${mediaLinks.regular}?${Math.random().toString(36)}`}
                             className={style.regularImage}
                             alt="" key={mediaLinks.regular}/>
                    </div>
                }
                {!isUploadRegularInProgress ?
                    <Button color={"primary"}
                            onClick={() => {
                                setMediaType(MediaType.regular);
                                setCurrentFile(currentFile);
                                setIsUploadRegularInProgress(true);
                                setIsImageRegularCropperVisible(true);
                            }}>
                        {t("menu:menuEditor.customizeRegular")}</Button>
                    :
                    <CircularProgress
                        m={2}
                        color="secondary"
                    />
                }
            </div>
        );
    }


    return (
        <FadeInOutVertical show={true}>
            <div style={{maxWidth: 800}}>
                {history.length > 1 && <BackButton/>}
                <Typography variant={"h4"} mb={3}>
                    {t("menu:menuEditor.commonInformation")}
                </Typography>
                <Paper p={5}>
                    <div>

                        <LocalizedInput
                            label={t("general:name")}
                            value={current.data.name}
                            setNewValue={bookingStore.setMenuItemName.bind(bookingStore)}
                        />

                        <LocalizedInput
                            label={t("general:description")}
                            value={current.data.description}
                            setNewValue={bookingStore.setMenuItemDescription.bind(bookingStore)}
                            numberOfLines={5}
                        />

                        <FormControl fullWidth variant="outlined" mt={5}>
                            <InputLabel htmlFor="menuCategorySelect">{t("menu:menuEditor.category")}</InputLabel>
                            <Select
                                //disabled={hasIIkoIntegration}
                                inputProps={{
                                    id: "menuCategorySelect"
                                }}
                                value={category || categoryId}
                                onChange={changeEventHandlerDecorator(setCategory)}
                                input={<OutlinedInput
                                    labelWidth={80}
                                />}
                            >
                                {
                                    bookingStore.currentMenu.menuCategories.map((item) => {
                                        return <MenuItem value={item.id} key={item.id}>
                                            {item.data.name[locale]}
                                        </MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>

                        <Typography variant={"h6"} mt={5} mb={2}>
                            {t("menu:menuEditor.positionPhoto")}
                        </Typography>
                        <div className={style.imageBlockContent}>
                            {imageBlockContent}
                        </div>
                        <Typography variant={"h6"} mt={5} mb={2}>
                            {t("menu:menuEditor.specialPositionMark")}
                        </Typography>
                        <FormControl>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={newBadgeChecked}
                                            onChange={changeCheckboxEventHandlerDecorator(setNewBadgeChecked)}
                                            value={current.data.badges.New.isEnabled}
                                        />
                                    }
                                    label={t("menu:badgeType.New")}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={profitableBadgeChecked}
                                            onChange={changeCheckboxEventHandlerDecorator(setProfitableBadgeChecked)}
                                            value={current.data.badges.Profitable.isEnabled}
                                        />
                                    }
                                    label={t("menu:badgeType.Profitable")}
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hitBadgeChecked}
                                            onChange={changeCheckboxEventHandlerDecorator(setHitBadgeChecked)}
                                            value={current.data.badges.Hit.isEnabled}
                                        />
                                    }
                                    label={t("menu:badgeType.Hit")}
                                />
                            </FormGroup>
                        </FormControl>
                    </div>
                </Paper>

                <FlexRowSpaceBetween style={{maxWidth: 800, marginTop: 80}}>
                    <Typography variant={"h4"}>
                        {t("menu:menuEditor.Sale")}
                    </Typography>
                    <FormControl>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isInStopList}
                                    //disabled={hasIIkoIntegration}
                                    onChange={changeCheckboxEventHandlerDecorator(setIsInStopList)}
                                    value={!isInStopList}
                                />
                            }
                            label={t("menu:menuEditor.inStopList")}
                        />
                    </FormControl>
                </FlexRowSpaceBetween>


                <Paper p={5}>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell>{t("menu:menuEditor.price")}</TableCell>
                                <TableCell align="right">
                                    <FormControl my={0}>
                                        <TextField
                                            InputProps={{
                                                endAdornment: <InputAdornment
                                                    position="end">{generalStore.currency.currencyShortName[locale]}</InputAdornment>
                                            }}
                                            inputProps={{min: 1, style: {textAlign: 'right', width: 100}}}
                                            onChange={changeEventHandlerDecorator(setPriceWrapper)}
                                            value={priceToShow}
                                        />
                                    </FormControl>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{t("menu:menuEditor.amount")}</TableCell>
                                <TableCell align="right">
                                    <FormControl my={0}>
                                        <TextField
                                            InputProps={{
                                                endAdornment: <InputAdornment
                                                    position="end">{t("general:units.pieces")}</InputAdornment>
                                            }}
                                            inputProps={{min: 1, style: {textAlign: 'right', width: 100}}}
                                            onChange={changeEventHandlerDecorator(setAmount)}
                                            value={amount}
                                        />
                                    </FormControl>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Paper>

                <Space size={20}/>
                <FlexRowSpaceBetween maxWidth={800}>
                    <Typography variant={"h4"}>
                       {t("menu:menuEditor.bookingTime")}
                    </Typography>
                    <Button color={'primary'} onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                       openScheduleForm(current)
                    }}>
                        {t("general:setUp")}
                    </Button>
                </FlexRowSpaceBetween>

                {
                    current.data.bookingScheduleSettings.step > 0 &&
                    <Paper p={5} style={{maxWidth: 800, width: "100%"}}>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        <Typography> {t("menu:menuEditor.bookingStep")}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        {current.data.bookingScheduleSettings.step} {t("general:min")}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography>{t("menu:menuEditor.bookingInterval")}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        {moment(timeFromSlot).format("HH:mm")} - {moment(timeToSlot).format("HH:mm")}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Paper>
                }

                <Space size={20}/>
                <FlexRowSpaceBetween maxWidth={800}>
                    <Typography variant={"h4"}>
                        {t("menu:menuEditor.modifiers")}
                    </Typography>
                    <Hidden smDown>
                        <Button color={'primary'} onClick={() => {
                            setIsAddModifersSetFormVisible(true);
                        }} mt={-1}>
                            {t("menu:menuEditor.addSet")}
                        </Button>
                    </Hidden>
                </FlexRowSpaceBetween>

                {
                    modifiersSets.length === 0 && <Paper p={5} style={{maxWidth: 800, width: "100%"}}>
                        <Centered>
                            <div>
                                <Typography component="h4" variant="h4" align="center" gutterBottom>
                                    {t("menu:menuEditor.addModifiersSet")} <span role="img"
                                                                                 aria-label='newCategory'>🍒</span>
                                </Typography>
                                <Typography component="h4" variant="body2" align="center" gutterBottom>
                                    {t("menu:menuEditor.addVarietiesOfDish")} <br/>
                                    {t("menu:menuEditor.addAdditionalIngredients")} <br/>
                                    {t("menu:menuEditor.createCombo")}
                                </Typography>
                                <div style={{display: "flex", justifyContent: "center", marginTop: 20}}>
                                    <Button variant="contained"
                                            color="primary"
                                            onClick={() => setIsAddModifersSetFormVisible(true)}
                                    >
                                        <AddIcon/>
                                        {t("menu:menuEditor.addModifiersToPosition")}
                                    </Button>
                                </div>
                            </div>
                        </Centered>

                    </Paper>
                }

                {
                    modifiersSets.map((item, index) => {
                        return <Paper p={5} mb={5} mt={2} style={{maxWidth: 800, width: "100%"}}>
                            <EditModifiersSetInline
                                key={`${item.menuItemModifierSetId}_${index}`}
                                id={item.menuItemModifierSetId}
                                remove={getRemoveModifiersSet(index)}
                            />
                        </Paper>
                    })
                }
                {
                    modifiersSets.length > 0 && <Hidden mdUp>
                        <Button color={'primary'}
                                onClick={() => {
                                    setIsAddModifersSetFormVisible(true);
                                }}
                                mt={-1}
                                fullWidth
                                variant={'contained'}
                        >
                            {t("menu:menuEditor.addSet")}

                        </Button>
                    </Hidden>
                }

                <DeleteMenuItemForm/>
                <EditBookingSheduleForm/>

                <Hidden smDown>
                    <FlexRowSpaceBetween style={{marginTop: 90}}>
                        <div>
                            <Button
                                color="default"
                                mr={5}
                                onClick={(e: React.MouseEvent) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    openDeleteForm(current);
                                }}
                            >
                                <RemoveIcon color="error"/>
                                {t("menu:menuEditor.deleteCard")}
                            </Button>
                        </div>
                        <div>
                            <Button
                                color="secondary"
                                mr={5}
                                onClick={() => {
                                    history.goBack()
                                }}
                            >
                                {t("general:back")}
                            </Button>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={handleSubmit}
                            >
                                {t("general:save")}
                            </Button>
                        </div>
                    </FlexRowSpaceBetween>
                </Hidden>
                <Hidden mdUp>
                    <Button
                        mt={5}
                        fullWidth
                        variant='outlined'
                        color="secondary"
                        onClick={() => {
                            history.goBack()
                        }}
                    >
                        {t("general:back")}
                    </Button>

                    <Button
                        mt={2}
                        fullWidth
                        color="primary"
                        variant="contained"
                        onClick={handleSubmit}
                    >
                        {t("general:save")}
                    </Button>
                    <Button
                        mt={2}
                        fullWidth
                        variant='outlined'
                        color="secondary"
                        //disabled={hasIIkoIntegration}
                        onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openDeleteForm(current);
                        }}
                    >
                        <RemoveIcon color="error"/>
                        {t("menu:menuEditor.deleteCard")}
                    </Button>
                </Hidden>

                <ImageCropperForm
                    open={isImagePreviewCropperVisible}
                    close={() => {
                        setIsImagePreviewCropperVisible(false);
                        setIsUploadPreviewInProgress(false);
                    }}
                    image={currentFile}
                    uploadImage={customizeImage}
                    aspectRation={ImageAspectRatio.rectangle_3_2}
                    name={fileName}
                />
                <ImageCropperForm
                    open={isImageRegularCropperVisible}
                    close={() => {
                        setIsImageRegularCropperVisible(false);
                        setIsUploadRegularInProgress(false);
                    }}
                    image={currentFile}
                    uploadImage={customizeImage}
                    aspectRation={ImageAspectRatio.rectangle_3_2}
                    name={fileName}
                />
                <AddModifiersSetToMenuItemForm
                    closeForm={closeAddModifierSetForm}
                    addToSet={submitAddModifiersSetForm}
                    isOpen={isAddModifersSetFormVisible}
                />
            </div>
        </FadeInOutVertical>

    );
};

export default observer(EditBookingItemPage);
